import React from 'react';
import styled from '@emotion/styled';

const Component: React.FCX<{ emoji: string }> = ({ className, emoji }) => <div className={className}>{emoji}</div>;

const StyledComponent = styled(Component)`
  width: 100px;
  height: 100px;
  font-size: 3em;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &:before {
    position: absolute;
    content: '';
    z-index: -1;
    background: linear-gradient(217deg, var(--color-primary-light), #fff);
    width: 90px;
    height: 90px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 63% 37% 54% 46% / 55% 48% 52% 45%;
  }
`;

export default StyledComponent;
